import React from 'react';
import { TopBar } from '../components/TopBar';
import { HeroSection } from '../components/HeroSection';
import { PresentationSection } from '../components/PresentationSection';
import { ParabolasHighlightSection } from '../components/ParabolasHighlightSection';
import { CollectionSection } from '../components/CollectionSection';
import { PreviewCarousel } from '../components/PreviewCarousel';
import { EmotionalSection } from '../components/EmotionalSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { SalesSection } from '../components/SalesSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" style={{
    fontFamily: "'Nunito', sans-serif"
  }} data-id="element-204">
      <MetaPixel data-id="element-205" />
      <TopBar data-id="element-206" />
      <HeroSection data-id="element-207" />
      <PresentationSection data-id="element-208" />
      <ParabolasHighlightSection data-id="element-209" />
      <CollectionSection data-id="element-210" />
      <PreviewCarousel data-id="element-211" />
      <EmotionalSection data-id="element-212" />
      <TestimonialsSection data-id="element-213" />
      <SalesSection data-id="element-214" />
      <FAQSection data-id="element-215" />
      <SocialProofPopup data-id="element-216" />
    </main>;
}